<template>
  <div class="container-fluid">
    <div v-if="!submitted">
      <div class="form-group">
        <h5>{{ $t('status.new') }}</h5>
        <div class="row">
          <div class="col-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('common.name') }}</span>
              </div>
              <input id="name" v-model="status.name" required class="form-control" name="name">
            </div>
            <span v-if="msg.name" class="alert-msg">{{msg.name}}</span>
          </div>
          <div class="col-4">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <label class="input-group-text" for="writePermissions">{{ $t('extra_field.write_permission') }}</label>
              </div>
              <select id="writePermissions" v-model="status.writePermissions" class="custom-select">
                <option :value="0">
                  {{ $t('extra_field.role_super') }}
                </option>
                <option :value="1">
                  {{ $t('extra_field.role_admin') }}
                </option>
                <option :value="2">
                  {{ $t('extra_field.role_all') }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 input-group mb-1">
            <div class="input-group-prepend">
              <label class="input-group-text" for="type">{{ $t('status.first') }}</label>
            </div>
            <div class="form-control">
              <input id="first" v-model="status.first" :disabled="status.type === 0" type="checkbox">
              <label for="first" class="ml-2">{{ $t('status.first_desc') }}</label>
            </div>
          </div>
          <div class="col-6 input-group mb-1">
            <div class="input-group-prepend">
              <label class="input-group-text" for="type">{{ $t('status.last') }}</label>
            </div>
            <div class="form-control">
              <input id="last" v-model="status.last" :disabled="status.type === 0" type="checkbox">
              <label for="last" class="ml-2">{{ $t('status.last_desc') }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-group mb-1">
            <div class="input-group-prepend">
              <label class="input-group-text" for="type">{{ $t('status.triggers') }}</label>
            </div>
            <textarea id="triggers" v-model="status.triggers" class="form-control" name="triggers" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 input-group mb-1">
            <div class="input-group-prepend">
              <label class="input-group-text" for="nextStatus">{{ $t('status.next_status') }}</label>
            </div>
            <select id="nextStatus" v-model="status.nextStatus" class="custom-select" multiple>
              <option v-for="(aStatus, index) in statusArray" :key="index" :value="aStatus">
                {{aStatus.name}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <p>
        <b>Acciones posibles:</b> "customer" (determina si existe alguna variable exclusiva o de uso exclusivo para un cliente. ej: "customer":"vuTick")<br>
        "sendmailCustomer" (se usa para enviar un correo ni bien se guarde en este estado, [la primera vez que entra en este estado], ej: "sendmailCustomer":"true", enviará el correo al cliente)<br>
        <!-- "mailbody" (se usa con el anterior para enviar determinado cuerpo de mensaje en el mail)<br> -->
        Todas las acciones pueden concatenarse, ejemplifico aquí: "sendmailCustomer":"true","sendmailAssignee":"true","className":"danger"<br>
        "className" (agrega al ticket con esta acción una clase específica, naturalmente se usa para agregarle un color específico, abajo las diferentes variables.)
      </p>
      <p>
        <span class="badge mr-1 badge-primary">
          primary
        </span>
        <span class="badge mr-1 badge-secondary">
          secondary
        </span>
        <span class="badge mr-1 badge-success">
          success
        </span>
        <span class="badge mr-1 badge-danger">
          danger
        </span>
        <span class="badge mr-1 badge-warning">
          warning
        </span>
        <span class="badge badge-info">
          info
        </span>
      </p>

      <button class="btn btn-success" @click="saveStatus">
        {{ $t('action.save') }}
      </button>
      <button class="btn btn-outline-danger btn-reset" @click="newStatus">
        {{ $t('action.reset') }}
      </button>
    </div>

    <div v-else>
      <h4>{{ $t('message.saved_ok') }}</h4>
      <button class="btn btn-success" @click="newStatus">
        {{ $t('action.save_another') }}
      </button>
    </div>
  </div>
</template>

<script>
import StatusService from '@/services/status.service';

export default {
    name: 'AddStatus',
    data() {
        return {
            statusArray: [],
            status: {
                name: '',
                triggers: '',
                first: false,
                last: false,
                nextStatus: [],
                writePermissions: 2
            },
            msg: {
                name: ''
            },
            submitted: false
        };
    },
    watch: {
        'status.name': function watchName(value) {
            if (value.length > 2) {
                this.msg['name'] = '';
            }
        }
    },
    created() {
        this.getStatus();
    },
    methods: {
    /* eslint-disable no-console */
        validForm(data) {

            if (!data.name || !data.name.length) {

                if (!data.name || !data.name.length ) {
                    this.msg['name'] = 'Nombre requerido.';
                }

                return false;
            }
            return true;
        },
        saveStatus() {
            var self = this;

            var data = {
                name: this.status.name,
                triggers: this.status.triggers,
                type: this.status.type,
                first: this.status.first,
                writePermissions: this.status.writePermissions,
                nextStatus: this.status.nextStatus,
                last: this.status.last
            };

            if (this.validForm(data)) {

                StatusService.saveStatus(data)
                    .then(response => {
                        this.submitted = true;

                        setTimeout(function forceNewControl() {
                            self.newStatus();
                        }, 5000);
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                            error.message || error.toString());
                    });

            }
        },
        getStatus() {
            StatusService.getStatus(true).then(
                response => {
                    this.statusArray = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        newStatus() {
            // Get status again.
            this.getStatus();
            this.submitted = false;
            this.status = {
                name: '',
                triggers: '',
                first: false,
                last: false,
                nextStatus: [],
                writePermissions: 2
            };
            this.msg = {
                name: ''
            };
        }
    /* eslint-enable no-console */
    }
};
</script>

<style lang="scss">
.alert-msg {
    color: #F00;
    padding-left: 13px;
    display: block;
    font-size: 12px;
}
.btn-reset {
    margin-left: 5px;
}
</style>
